import { z } from 'zod';
export const createStudentSchema = z.object({
    first_name: z.string().min(2).max(100),
    last_name: z.string().min(2).max(200),
    email: z.string().email(),
    phone: z
        .string()
        .regex(/^[6789]\d{8}$/, 'Teléfono inválido')
        .optional(),
    dni: z
        .string()
        .regex(/^\d{8}[A-Z]$/, 'DNI inválido (formato: 12345678A)'),
    address: z.string().max(300).optional(),
    birth_date: z.string().date('Fecha inválida').optional(),
    /**
     * Fecha en la que el alumno EMPIEZA (clases y cobro). Por defecto hoy
     * (server-side). Si es futura: sin cuota inicial (la genera el cron cuando
     * llegue el mes) y no aparece al pasar lista hasta esa fecha.
     */
    start_date: z.string().date('Fecha inválida').optional(),
    opposition_id: z.string().uuid(),
    shift_id: z.string().uuid(),
    student_number: z.number().int().positive().max(99999).optional(),
});
export const updateStudentSchema = createStudentSchema.partial().omit({ email: true, dni: true });
export const studentSearchQuerySchema = z.object({
    q: z.string().trim().min(1).max(100),
    limit: z.coerce.number().int().min(1).max(20).default(10),
});
//# sourceMappingURL=student.schema.js.map